import config from '@/config';
import { getNormalizedHosts, getParentDomain, normalizeHostname } from '@/utils/runtimeHostnames';

type RuntimeConfig = {
  AUTH_UI_ALIASES?: string[];
  AUTH_UI_URL?: string;
  COOKIE_DOMAIN?: string;
  SDK_API_ALIASES?: string[];
  SDK_API_URL?: string;
};
const getAliasSet = (aliases: unknown) => new Set(getNormalizedHosts(aliases));

const getSdkApiAliasMap = (aliases: string[]) => {
  const aliasMap = new Map<string, string>();

  aliases
    .forEach(alias => {
      const parentDomain = getParentDomain(alias);

      if (parentDomain) {
        aliasMap.set(parentDomain, alias);
      }
    });

  return aliasMap;
};

export const resolveAuthUiRuntime = (
  runtimeConfig: RuntimeConfig,
  location = typeof window !== 'undefined' ? window.location : undefined,
) => {
  const currentHostname = location ? normalizeHostname(location.hostname) : '';
  const currentProtocol = location?.protocol || 'https:';
  const configuredAliases = getAliasSet(runtimeConfig.AUTH_UI_ALIASES);
  const sdkApiAliasesByParentDomain = getSdkApiAliasMap(getNormalizedHosts(runtimeConfig.SDK_API_ALIASES));
  const aliasModeEnabled = Boolean(currentHostname) && configuredAliases.has(currentHostname);
  const currentParentDomain = aliasModeEnabled ? getParentDomain(currentHostname) : '';
  const matchingSdkApiAlias = currentParentDomain
    ? sdkApiAliasesByParentDomain.get(currentParentDomain)
    : undefined;

  return {
    aliasModeEnabled,
    authCookieDomain: currentParentDomain || runtimeConfig.COOKIE_DOMAIN || '',
    authUiUrl: aliasModeEnabled && location ? location.origin : runtimeConfig.AUTH_UI_URL || '',
    currentHostname,
    currentParentDomain,
    sdkApiUrl: matchingSdkApiAlias
      ? `${currentProtocol}//${matchingSdkApiAlias}`
      : runtimeConfig.SDK_API_URL || '',
  };
};

const runtime = resolveAuthUiRuntime(config);

export const authUiUrl = runtime.authUiUrl;
export const authCookieDomain = runtime.authCookieDomain;
export const sdkApiUrl = runtime.sdkApiUrl;
